import { render, staticRenderFns } from "./LiveOps.vue?vue&type=template&id=52fbafd4&scoped=true"
import script from "./LiveOps.vue?vue&type=script&lang=js"
export * from "./LiveOps.vue?vue&type=script&lang=js"
import style0 from "./LiveOps.vue?vue&type=style&index=0&id=52fbafd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fbafd4",
  null
  
)

export default component.exports